import React from 'react';
import { Icon } from 'merchant-portal-components';

const ChevronDownIcon = (props) => (
  <Icon className="fa fa-chevron-down" {...props} />
);

export default ChevronDownIcon;
